function TailSweep() {

}


TailSweep.scriptFontsTailSweep = [
    "Dodgers",
    "Royals",
    "Orioles",
    "San Francisco Giants"
];

TailSweep.blockFontsTailSweep = [
    "Twins"
];

TailSweep.funcs = {
    createTailSweepApplication: function(teamNameSettings, tailSweepName, tailSweepSettingsObject) {
        var configuration = TeamNamePanel.configuration;
        var part = "Front Body";

        if (typeof teamNameSettings !== "undefined") {
            if (tailSweepName !== "none") {
                teamNameSettings.hasTailSweeps = true;

                var accent = teamNameSettings.accent_obj.code;
                // Get tailsweep object
                var tailsweepObject = TailSweep.funcs.getTailSweepStockMascot(tailSweepName, accent);

                if (typeof tailsweepObject !== "undefined") {
                    if (typeof tailSweepSettingsObject !== "undefined") {
                        TailSweep.funcs.changeTailSweep(tailsweepObject.id, tailSweepSettingsObject);
                    } else {
                        TailSweep.funcs.addTailSweep(
                            configuration.perspective,
                            part,
                            "mascot",
                            configuration.side,
                            tailsweepObject.id,
                            function(tailSweepSettings) {
                                // Set TEAM NAME CODE in TAILSWEEP
                                tailSweepSettings.team_name_code = teamNameSettings.code;

                                // Post Process
                                TailSweep.funcs.rePositionTailSweep(teamNameSettings.code, tailSweepSettings.code);
                                ub.funcs.activateMoveTool(tailSweepSettings.code);
                            }
                        );
                    }

                    // Sync COLOR
                    TailSweep.funcs.syncTailSweepColor(teamNameSettings.code, teamNameSettings.tailSweepColorSyncLayers);
                } else {
                    ub.utilities.info("No available tailsweep for accent " + accent);
                }
            } else {
                teamNameSettings.hasTailSweeps = false;
                // Remove tailsweep application
                if (typeof tailSweepSettingsObject !== "undefined") {
                    ub.funcs.deleteLocation(tailSweepSettingsObject.code)
                }
            }
        }
    },

    filterTailSweeps: function(font_alias) {
        var tailSweeps = _.filter(ub.data.tailSweeps, function(tail) {
            // Change Image URL
            tail.thumbnail = ub.utilities.changeAssetUrl(tail.thumbnail);

            if (tail.brand_id !== null) {
                if (_.contains(ub.data.scriptFonts, font_alias)) {
                    if (_.contains(TailSweep.scriptFontsTailSweep, tail.name)) {
                        return tail;
                    }
                } else {
                    if (_.contains(TailSweep.blockFontsTailSweep, tail.name)) {
                        return tail;
                    }
                }
            }
        });

        return tailSweeps;
    },

    changeTailSweepsPerFontStyle: function(filter, teamObject, tailSweepObject) {
        var accent = teamObject.accent_obj.name.toLowerCase();
        if (accent.includes("with")) {
            accent = accent.replace(" with", "");
        }

        var scriptTailSweep = _.filter(ub.data.tailSweepStockMascot, function(tail) {
            if (_.contains(filter, ub.utilities.titleCase(tail.alias))) {
                if (tail.code.toLowerCase() === accent) {
                    return tail;
                }
            }
        });

        var tailSweep = _.first(scriptTailSweep);
        
        if (typeof tailSweep !== "undefined") {
            TailSweep.funcs.changeTailSweep(tailSweep.id, tailSweepObject);
            TailSweep.funcs.syncTailSweepColor(teamObject.code, teamObject.tailSweepColorSyncLayers);
        } else {
            teamObject.hasTailSweeps = false;
            ub.funcs.deleteLocation(tailSweepObject.code)
            ub.utilities.info("Cannot find available tailsweep");
        }
    },

    changeTailSweepColor: function(layer_name, colorObject, application) {
        // Change tail sweep mascot
        var tailSweepObject = TailSweep.funcs.getTailSweepSettings(application.code);

        if (typeof tailSweepObject !== "undefined") {
            if (application.hasTailSweeps && typeof tailSweepObject !== "undefined") {
                var mascotLayer = _.find(tailSweepObject.mascot.layers_properties, {layer_name: layer_name});
                if (typeof mascotLayer !== "undefined") {
                    ub.funcs.changeMascotColor(colorObject, mascotLayer.layer_number, tailSweepObject);
                }
            }
        }
    },

    getTailSweepStockMascot: function(tailSweep, accent) {
        var remove = accent.replace(/_/g, " ");
        var tailLowerCase = tailSweep.toLowerCase();
        var tailSweeps = _.filter(ub.data.tailSweepStockMascot, function(tail) {
            if (tail.alias.toLowerCase() === tailLowerCase) {
                return tail;
            }
        });

        if (_.size(tailSweeps) !==  0) {
            var tailObj = _.find(tailSweeps, {code: remove});

            if (typeof tailObj !== "undefined") {
                return tailObj;
            }
        }
    },

    addTailSweep: function(perspective, part, type, side, mascotId, callback) {
        var that = this;
        ApplicationCore.funcs.createStockMascot(perspective, part, side, mascotId, callback);
    },

    changeTailSweep: function(_mascotID, settingsObj) {
        ApplicationCore.utilities.changeMascot(_mascotID, settingsObj);
    },

    getTailSweepSettings: function(team_name_code) {
        var tailSweep;

        if (typeof team_name_code !== "undefined") {
            tailSweep = _.find(ub.current_material.settings.applications, {
                isTailSweep: true,
                application_type: "mascot",
                team_name_code: team_name_code
            });
        } else {
            tailSweep = _.find(ub.current_material.settings.applications, {
                isTailSweep: true,
                application_type: "mascot"
            });
        }
        return tailSweep;
    },

    syncTailSweepColor: function(team_name_code, colorArray) {
        var tailSweepObject = TailSweep.funcs.getTailSweepSettings(team_name_code);
        
        if (typeof tailSweepObject !== "undefined") {
            _.each(colorArray, function(layer, index) {
                var mascotLayer = _.find(tailSweepObject.mascot.layers_properties, {layer_name: layer.layer_name});
                if (typeof mascotLayer !== "undefined") {
                    ub.funcs.changeMascotColor(layer.color_obj, mascotLayer.layer_number, tailSweepObject);
                }
            });
        }
    },

    isAccentHasTailSweep: function(accent) {
        var remove = accent.replace(/_/g, " ");
        var tailSweeps = _.filter(ub.data.tailSweepStockMascot, function(tail) {
            if (tail.code.toLowerCase() === remove.toLowerCase()) {
                return tail;
            }
        });

        if (_.size(tailSweeps) > 0) {
            return true;
        }

        return false;
    },

    rePositionTailSweep: function(teamNameCode, tailSweepCode) {
        var teamName = ub.funcs.getApplicationSettings(teamNameCode);
        var perspectiveTeamName = teamName.application.views[0].perspective;

        var _objteamName = ub.objects[perspectiveTeamName + '_view']['objects_' + teamName.code];
        var teamNamePosition = _objteamName.position;

        var tailSweepObject = ub.funcs.getApplicationSettings(tailSweepCode);

        if (typeof tailSweepObject !== "undefined") {
            var perspectiveTailSweep = tailSweepObject.application.views[0].perspective;
            var tailSprite = ub.objects[perspectiveTailSweep + '_view']['objects_' + tailSweepObject.code];

            tailSprite.position = {
                x: teamNamePosition.x,
                y: teamNamePosition.y + 50
            }

            var application = tailSweepObject.application.views[0].application;
            application.center = tailSprite.position;

            var _locationMarker = ub.objects[perspectiveTailSweep + '_view']['locations_' + tailSweepObject.code];
            _locationMarker.position = tailSprite.position;

            ub.funcs.updateCoordinates(tailSweepObject);
            ub.updateApplicationSpecsPanel(tailSweepObject.code);
        }
    },

    changeUpdateTailSweepAccent: function(application, accentCode) {
        if (typeof application.hasTailSweeps !== "undefined" && application.hasTailSweeps) {
            var tailSweepSettingsObject = TailSweep.funcs.getTailSweepSettings(application.code);
             var newTailSweep = TailSweep.funcs.getTailSweepStockMascot(tailSweepSettingsObject.mascot.alias, accentCode);
            // Change Tail Sweep
            if (typeof newTailSweep !== "undefined") {
                TailSweep.funcs.changeTailSweep(newTailSweep.id, tailSweepSettingsObject);
                TailSweep.funcs.syncTailSweepColor(application.code, application.tailSweepColorSyncLayers);
            } else {
                // Remove tailsweep application
                if (typeof tailSweepSettingsObject !== "undefined") {
                    ub.funcs.deleteLocation(tailSweepSettingsObject.code);
                    application.hasTailSweeps = false;
                }

                ub.utilities.info("No available tailsweep for accent " + accentCode);
            }
        }
    },

    hideShowTailSweep: function(accentCode) {
        if (!TailSweep.funcs.isAccentHasTailSweep(accentCode)) {
            $(".team-name-panel .tail-sweep-container").hide();
        } else {
            $(".team-name-panel .tail-sweep-container").show();
        }
    },

    afterRemoveTailSweep: function() {
        // Find Team name with tailsweep
        var teamname = _.find(ub.current_material.settings.applications, {application_type: "team_name", hasTailSweeps: true});

        if (typeof teamname !== "undefined") {
            teamname.hasTailSweeps = false;
            TeamNamePanel.funcs.initializeTeamName(teamname.code);
        }
    },

    scriptAndBlockFontTailSweep: function(settingsObject, newFont) {
        if (typeof settingsObject.hasTailSweeps !== "undefined" && settingsObject.hasTailSweeps) {
            // Get TailSweep
            var tailSweepSettingsObject = TailSweep.funcs.getTailSweepSettings(settingsObject.code);
            
            if (typeof tailSweepSettingsObject !== "undefined") {
                if (!_.contains(ub.data.scriptFonts, newFont.alias)) {
                    // Script Fonts
                    if (!_.contains(TailSweep.scriptFontsTailSweep, tailSweepSettingsObject.mascot.alias)) {
                        TailSweep.funcs.changeTailSweepsPerFontStyle(TailSweep.blockFontsTailSweep, settingsObject, tailSweepSettingsObject);
                    }
                } else {
                    // Block Fonts
                    if (!_.contains(TailSweep.blockFontsTailSweep, tailSweepSettingsObject.mascot.alias)) {
                        TailSweep.funcs.changeTailSweepsPerFontStyle(TailSweep.scriptFontsTailSweep, settingsObject, tailSweepSettingsObject);
                    }
                }
            }
        }

        TeamNamePanel.funcs.initializeTeamName(settingsObject.code);
    }
}